import { format } from 'date-fns';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import type { ReleaseNote } from '@/types';

import { RELEASE_NOTE_SHORT_DATE } from '@/utils/constants';
import { getDateFnsLocale } from '@/utils/helpers/get-date-fns-locale';

interface ReleaseNotesListItemProps {
  release: ReleaseNote;
}

const ReleaseNotesListItem: FC<ReleaseNotesListItemProps> = ({ release }) => {
  const { t } = useTranslation();

  const { version, releaseDate, isCurrent } = release;

  const currentLocale = getDateFnsLocale();

  const formattedDate = format(new Date(releaseDate), RELEASE_NOTE_SHORT_DATE, {
    locale: currentLocale,
  });

  return (
    <div className="flex flex-col items-start text-left gap-1">
      <span className="font-semibold flex gap-1 text-base">
        <span>{version}</span>
        {isCurrent && <span>({t('release_note.current')})</span>}
      </span>
      <span className="text-xs text-muted-foreground font-normal">{formattedDate}</span>
    </div>
  );
};

export default ReleaseNotesListItem;
